const toggles = document.querySelectorAll('[data-toggle-filters]');

export default () => {
  toggles.forEach((toggle) => {
    // selectors and data
    const wrapper = document.querySelector('#bc-sf-filter-tree-h');
    const selector = '#bc-sf-filter-tree-h .bc-sf-filter-option-block';

    const classes = {
      filtersClosed: 'bc-sf-filter-tree-h--closed',
      rotateToggle: 'bc-sf-filter-chevron--rotate',
    };

    // functions
    const openContent = () => {
      const contentBlocks = document.querySelectorAll(selector);

      contentBlocks.forEach((content) => {
        content.setAttribute('aria-expanded', true);

        content.style.display = 'block';
        content.style.transition = 'height .3s';
        content.style.margin = '';

        const contentHeight = content.scrollHeight;
        content.style.height = `${contentHeight}px`;
      });
      wrapper.classList.remove(classes.filtersClosed);
      toggle.classList.remove(classes.rotateToggle);
    };

    const closeContent = () => {
      const contentBlocks = document.querySelectorAll(selector);
      contentBlocks.forEach((content) => {
        content.setAttribute('aria-expanded', false);

        const contentHeight = content.scrollHeight;

        content.style.height = `${contentHeight}px`;
        content.style.transition = '.3s';
        content.style.overflow = 'hidden';
        content.style.margin = '0';

        window.requestAnimationFrame(() => {
          // “pausing” the JavaScript execution to let the rendering threads catch up
          // http://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
          setTimeout(() => {
            content.style.height = 0;
          }, 0);
        });
      });
      toggle.classList.add(classes.rotateToggle);
    };

    const addTransitionEnds = () => {
      const contentBlocks = document.querySelectorAll(selector);

      contentBlocks.forEach((content) => {
        content.addEventListener('transitionend', handleTransitionEnd);

        // stop the above line of code from running in the case of a tag animating on focus or hover
        content.querySelectorAll('a')
          .forEach((el) => el.addEventListener('transitionend', (e) => e.stopPropagation()));
      });
    };

    const toggleContent = () => {
      const contentBlocks = document.querySelectorAll(selector);
      const isOpen = contentBlocks[0].getAttribute('aria-expanded') !== 'false';

      addTransitionEnds();

      if (isOpen) {
        closeContent();
      } else {
        openContent();
      }
    };

    // handlers
    const handleTransitionEnd = (e) => {
      const isOpen = e.currentTarget.getAttribute('aria-expanded') !== 'false';

      if (isOpen) {
        e.currentTarget.style.height = 'auto';
      } else {
        wrapper.classList.add(classes.filtersClosed);
      }
      e.currentTarget.removeEventListener('transitionend', handleTransitionEnd);
    };

    // apply event listeners
    toggle.addEventListener('click', () => toggleContent());

    // toggle closed on load
    window.onload = () => {
      toggleContent();
    };
  });

  // Thumbnail filter
  const gridWrapper = document.getElementById('bc-sf-filter-products') || document.getElementById('bc-sf-filter-page');
  const filterButtons = document.querySelectorAll('.thumbnail-filter__button');
  const thumbnailEvent = (event) => {
    event.preventDefault();
    const button = event.currentTarget;
    const value = button.getAttribute('data-thumbnail-view');

    filterButtons.forEach((button) => {
      button.classList.remove('active');
    });

    if (!button.classList.contains('active')) {
      button.classList.add('active');
    }
    if (value === 'small') {
      gridWrapper.classList.add('product-thumbnail-view-small');
    } else {
      gridWrapper.classList.remove('product-thumbnail-view-small');
    }
  };

  if (gridWrapper && filterButtons) {
    filterButtons.forEach((button) => {
      button.addEventListener('click', thumbnailEvent);
    });
  }

  document.addEventListener('click', (event) => {
    const productImages = document.querySelectorAll('.bc-sf-filter-product-item-main-image');
    if (!event.target.classList.contains('thumbnail-filter__button') && productImages.length === 0) return;
    productImages.forEach((image) => {
      const imageHeight = image.clientHeight;
      image.parentElement.style.height = `${imageHeight}px`;
    });
  });
};
